document.addEventListener('DOMContentLoaded', () => {
  const megaWrappers = document.querySelectorAll('.mega-menu-wrapper');

  megaWrappers.forEach(wrapper => {
    const parentLinks = wrapper.querySelectorAll('.parent-links li');
    const megaContents = wrapper.querySelectorAll('.mega-content');

    function activate(index) {
      megaContents.forEach(c => c.classList.remove('active'));
      parentLinks.forEach(l => l.classList.remove('active'));
      const activeContent = wrapper.querySelector(`.mega-content[data-parent-index="${index}"]`);
      const activeLink = wrapper.querySelector(`.parent-links li[data-parent-index="${index}"]`);
      if (activeContent) activeContent.classList.add('active');
      if (activeLink) activeLink.classList.add('active');
    }

    parentLinks.forEach(link => {
      link.addEventListener('mouseenter', () => activate(link.dataset.parentIndex));
      link.addEventListener('focus', () => activate(link.dataset.parentIndex));
    });

    activate(0);
  });
});
